import router from '@/router'
import cmd from '@/common/Command'

const HeaderModule = {
  namespaced: true,
  state: {
  },
  mutations: {},
  actions: {
    menuAction ({ commit, state, rootState }) {
      rootState.currentMenu = ""
      router.push('/')
    },
    questionTopAction ({ commit, state, rootState }) {
      rootState.currentMenu = "question"
      router.push('question')

      //初期化
      this.dispatch("initQuestion")
    },
    //前ページ
    prevAction ({ commit, state, rootState }) {

      if (rootState.currentMenu == "question") {
        rootState.currentMenu = ""
        router.push('/')
      } else {
        router.go(-1)
      }
    },
    questionHomeAction ({ commit, state, rootState }) {

      var selectedQuestions = rootState.QuestionModule.selectedQuestions.length
      if (selectedQuestions > 0) {
        $("#confirmModal").remodal().open()
      } else {
        rootState.currentMenu = ""
        router.push('/')
      }
    },
    //演習問題トップ
    practiceTopAction ({ commit, state, rootState }) {
      rootState.currentMenu = 'practice'
      router.push('practice')
    },
  },
  getters: {
    version (state, getters, rootState) {
      return process.env.VERSION
    },
    showMenuLink (state, getters, rootState) {

      if (rootState.currentMenu != "") {
        return true
      } else {
        return false
      }
    },
    isQuestion (state, getters, rootState) {
      if (rootState.currentMenu.indexOf("question") >= 0) {
        return true
      } else {
        return false
      }
    },
    isGeo (state, getters, rootState) {
      if (process.env.SUBJECT == "geo") {
        return true
      } else {
        return false
      }
    },
    isHistory (state, getters, rootState) {
      if (process.env.SUBJECT == "history") {
        return true
      } else {
        return false
      }
    },
    isCivics (state, getters, rootState) {
      if (process.env.SUBJECT == "civics") {
        return true
      } else {
        return false
      }
    }
  }
}

export default HeaderModule



// WEBPACK FOOTER //
// ./src/store/modules/HeaderModule.js